import React from 'react';
import './App.css';
import VideoList from "./VideoList";
import { enableRipple, registerLicense } from '@syncfusion/ej2-base';
import debounce from 'lodash.debounce';


registerLicense('ORg4AjUWIQA/Gnt2VVhiQlFadVlJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxXdkRiXn5cdHNUQGBeWEw='); // 20.2.0.36

enableRipple(true);

type State = {
    searchQuery: string;
    debouncedSearchQuery: string;
}

interface Props {

}
class App extends React.Component<Props, State> {

    //private handleSearchChangeDebounced: (searchValue: string) => void;
    constructor(props: Props | Readonly<Props>) {
        super(props);
        this.state = {
            searchQuery: '',
            debouncedSearchQuery: ''
        };
        this.updateDebouncedSearchQuery = debounce(this.updateDebouncedSearchQuery, 1000);
    }


    handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ searchQuery: event.target.value });
        this.updateDebouncedSearchQuery(event.target.value);
    };

    
    updateDebouncedSearchQuery = (searchQuery: string) => {
        this.setState({ debouncedSearchQuery: searchQuery });
    };


    render() {
        return (
            <div className="container mx-auto px-4">
                <div className="my-4 search-container">
                    <button
                        className="search-button"
                    >
                        <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd">
                            <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
                        </svg>
                    </button>
                    <input
                        type="text"
                        className="search-input"
                        placeholder="Search Tutorials"
                        value={this.state.searchQuery}
                        onChange={this.handleSearchChange}
                    />

                </div>
                <VideoList searchQuery={this.state.debouncedSearchQuery} />
            </div>
        );



    }
}

export default App;
